document.addEventListener('DOMContentLoaded', function () {
    const selectors = ['#afterSalesIssue', '#productModel', '#purchasePlatform'];

    selectors.forEach(function (sel) {
        const s = document.querySelector(sel);
        if (!s) return;

        if (!(s.options.length && s.options[0].value === '')) {
            const placeholder = document.createElement('option');
            placeholder.value = '';
            placeholder.disabled = true;
            placeholder.selected = true;
            placeholder.hidden = true;
            placeholder.textContent = 'Select';
            s.insertBefore(placeholder, s.firstChild);
            s.dispatchEvent(new Event('change'));
        }

        function updatePlaceholderClass() {
            if (!s.value) s.classList.add('select-placeholder');
            else s.classList.remove('select-placeholder');
        }

        updatePlaceholderClass();

        s.addEventListener('change', updatePlaceholderClass);
        s.addEventListener('blur', updatePlaceholderClass);
    });
});
